/* eslint-disable */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import AdminDashboard from '../../admin/components/AdminMain';
import AdminLogin from './AdminLogin';
import { SET_USER_SESSION } from '../constants/ActionTypes';
import { SESSION_ADMIN_HEARTBEAT } from '../constants/endpoints';

const AdminContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    const sessionHeartBeatInterval = process.env.REACT_APP_SESSION_HB_INTERVAL || 5;
    
    useEffect(() => {
        window.scrollTo(0, 0);
        if (session && session?.jwtResponse?.token) {
            if (location.pathname === '/oasadmin/login') {
                navigate('/oasadmin/dashboard')
            } else {
                navigate(location.pathname)
            }
        }
        if (!session && !session?.jwtResponse?.token) {
            navigate("/oasadmin/login")
        }
    }, []);
    
    useEffect(() => {
        window.scrollTo(0, 0);
        const sessionInner = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        if(sessionInner && sessionInner.jwtResponse.token) {
            dispatch({
                type: SET_USER_SESSION,
                payload: sessionInner.jwtResponse.token,
                authData: sessionInner,
            })
        }
    }, [dispatch]);

    setInterval(() => {
        if(session && session.jwtResponse.token) {
            axiosInstanceWithoutEncrDecr.patch(SESSION_ADMIN_HEARTBEAT + `/${session.userId}`, {},  { headers: { 'Authorization': `Bearer ${session.jwtResponse.token}` } });
        }
    }, sessionHeartBeatInterval * 60 * 1000);

    if (session && session.jwtResponse.token) {
        return <AdminDashboard />
    } else {
        return <AdminLogin />
    }
}
export default AdminContainer;